import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { usePwaInstall } from '../../hooks/usePwaInstall.js';
import { useAuth } from '../../contexts/AuthContext.jsx';

export default function UserMenu() {
  const { user, logout } = useAuth();
  const { canInstall, install } = usePwaInstall();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const loc = useLocation();

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  useEffect(() => {
    function onPointer(e) {
      if (!open) return;
      if (ref.current && ref.current.contains(e.target)) return;
      setOpen(false);
    }
    function onKey(e) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('pointerdown', onPointer);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', onPointer);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  function handleLogout() { setOpen(false); logout(); }
  function handleInstall() { setOpen(false); install(); }
  function close() { setOpen(false); }

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        className="user-menu-trigger"
        aria-expanded={open}
        aria-haspopup="true"
        onClick={() => setOpen(v => !v)}
        title={user?.email}
      >
        <span className="user-menu-avatar" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
            <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clipRule="evenodd" />
          </svg>
        </span>
        <span className="user-menu-name">{user?.email || '—'}</span>
        <span className="user-menu-chevron" aria-hidden="true">{open ? '▴' : '▾'}</span>
      </button>

      {open && (
        <div className="user-menu-panel" role="menu">
          {canInstall && (
            <button type="button" role="menuitem" className="user-menu-item" onClick={handleInstall}>
              <span className="icon" aria-hidden="true">📲</span>
              Installa app
            </button>
          )}
          <Link to="/impostazioni" role="menuitem" className="user-menu-item" onClick={close}>
            <span className="icon" aria-hidden="true">🔐</span>
            Cambia password/PIN
          </Link>
          <button type="button" role="menuitem" className="user-menu-item text-danger" onClick={handleLogout}>
            <span className="icon" aria-hidden="true">🚪</span>
            Esci
          </button>
        </div>
      )}
    </div>
  );
}